import { Button, Spinner, Text, VStack } from '@chakra-ui/react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { MAX_CONTAINER_WIDTH } from '@/constants/dimensions';
import ContentGrid from '@/modules/content/common/ContentGrid';
import { getPersonalizedFeedInfiniteOptions } from '@/utils/queryOptions';

const CuratedContentPage = () => {
  const { data, isLoading, isError, refetch, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery(getPersonalizedFeedInfiniteOptions());
  const content = data?.pages.flatMap((page) => page.data) ?? [];

  return (
    <VStack width={MAX_CONTAINER_WIDTH} align="stretch" gap="24px">
      <Text variant="loraMediumTitle" color="text.darkBlue">Content Curated for You</Text>
      <Text color="text.mediumGray" fontWeight={500}>Explore content that helps you become whole.</Text>
      {isLoading ? <Spinner color="primary.500" /> : isError && !content.length ? (
        <VStack><Text>Unable to load curated content.</Text><Button onClick={() => refetch()}>Try again</Button></VStack>
      ) : content.length ? (
        <>
          <ContentGrid content={content} />
          {isError && <Text color="text.mediumBlue">Unable to load more content. Please try again.</Text>}
          {hasNextPage && <Button alignSelf="center" onClick={() => fetchNextPage()} isLoading={isFetchingNextPage}>Load more</Button>}
        </>
      ) : <Text color="text.mediumBlue">No curated content available yet. Check back soon.</Text>}
    </VStack>
  );
};

export const Route = createFileRoute('/_authenticated/_user/user/curated-content')({
  staticData: { title: 'Content Curated for You' },
  component: CuratedContentPage,
});
